import { type ComponentPropsWithoutRef, type FC } from 'react';
import { cn } from '../lib/utils';
import { Textarea as ShadTextarea } from './ui/textarea';

type TextareaProps = ComponentPropsWithoutRef<typeof ShadTextarea>;

export const Textarea: FC<TextareaProps> = (props) => {
  return (
    <ShadTextarea
      {...props}
      className={cn(
        'px-2 aria-invalid:ring-1 aria-invalid:ring-destructive',
        // Prevent user resizing, but allow auto-expanding
        'resize-none',
        // Override ui/textarea `dark:bg-input/30` → Figma `background/surface`.
        'dark:bg-background-surface',
        props.className,
      )}
    />
  );
};
